<template>
  <div class="wrapper">
    <div v-if="loading"
         class="circular-loader">
      <base-circular-loader color="primary"
                            size="medium" />
    </div>

    <div v-else
         class="tab-page">
      <search-list v-if="searches.length"
                   :searches="searches" />
      
      <searches-empty-screen v-else
                             :loading="loading"
                             @retry="onRetry" />
    </div>
  </div>
</template>

<script>
  import SearchList from './SearchList.vue'
  import SearchesEmptyScreen from './SearchesEmptyScreen.vue'

  import analytics from '@/services/analytics.js'

  export default {
    props: {
      childId: {
        type: String,
        required: true
      }
    },

    components: {
      SearchList,
      SearchesEmptyScreen
    },

    data() {
      return {
        loading: false
      }
    },

    created() {
      analytics.sendEvent('Srch_Tb')

      this.loadSearches()
    },

    methods: {
      async loadSearches() {
        this.loading = true

        await this.setSearches({
          user_id: this.childId,
          event_names: ['search']
        })

        this.loading = false
      },

      onRetry() {
        this.loadSearches()
      },

      ...mapActions('children', {
        setSearches: 'setSearches'
      })
    },

    computed: {
      ...mapGetters('children', {
        getSearches: 'getSearches'
      }),

      searches() {
        return this.getSearches(this.childId)
      }
    },

    watch: {
      childId() {
        this.loadSearches()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .wrapper {
    height: 100%;
    width: 100%;

    .circular-loader {
      width: 100%;
      height: 100%;

      display: flex;
      justify-content: center;
      align-items: center;
    }

    .tab-page {
      height: 100%;
      width: 100%;
    }
  }
</style>